<template>
  <v-alert
    type="info"
    :color="color"
    border="left"
    dense
    style="word-break: break-word;"
  >
    <template v-slot:prepend>
      <v-hover
        v-slot="{ hover }"
      >
        <v-btn
          fab
          small
          color="white"
          class="mr-3"
          :elevation="hover ? 12 : 3"
          :href="linkUrl"
          target="_blank"
        >
          <v-icon
            :color="color"
          >
            mdi-link
          </v-icon>
        </v-btn>
      </v-hover>
    </template>
    <span
      class="text-caption"
    >
      Link
    </span>
    <br />
    <span
      class="font-weight-bold"
      :class="{
        'text-body-2': $vuetify.breakpoint.xs
      }"
    >
      {{ text }}
    </span>
  </v-alert>
</template>

<script>

export default {
  name: 'LinkAlert',
  props: {
    color: String,
    text: String,
    linkUrl: String
  },
  data () {
    return { }
  },
  mounted () { },
  methods: { },
  computed: {
  }
}

</script>

<style>
</style>
